import { ref, watch } from 'vue';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export interface AppConfigOptions {
    defaultDismissableMask?: boolean;
    defaultCloseOnEscape?: boolean;
}

export const useReceiverUserConfigStore = defineStore(
    'receiver-config-store',
    () => {
        const defaultDismissableMask = ref<boolean>(false);
        const defaultCloseOnEscape = ref<boolean>(true);

        function configure(options: AppConfigOptions | null | undefined) {
            options ??= {};
            if (options.defaultDismissableMask !== undefined)
                defaultDismissableMask.value = options.defaultDismissableMask;
            if (options.defaultCloseOnEscape !== undefined)
                defaultCloseOnEscape.value = options.defaultCloseOnEscape;
        }

        const dismissableMask = useStorage<boolean>(
            'receiver-config-dismissable-mask',
            defaultDismissableMask
        );

        watch(dismissableMask, () => {
            console.log(dismissableMask);
        });

        const closeOnEscape = useStorage<boolean>(
            'receiver-config-close-on-escape',
            defaultCloseOnEscape
        );

        function toggleDismissableMask() {
            dismissableMask.value = !dismissableMask.value;
        }

        function toggleCloseOnEscape() {
            closeOnEscape.value = !closeOnEscape.value;
        }

        return {
            dismissableMask,
            closeOnEscape,

            toggleDismissableMask,
            toggleCloseOnEscape,

            configure,
        };
    }
);
